import { useState, useEffect, useRef } from "react";
import { SETSHOWSTORENAMEINHEADER } from "../redux/features/common";
import useAppDispatch from "./useAppDispatch";
export function useVisibility(threshold = 0.1) {
    const [isVisible, setIsVisible] = useState<any>(false);
    const dispatch = useAppDispatch()
    const elementRef = useRef<any>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                const mobile = window.innerWidth < 768;
                if (!mobile) return;

                dispatch(SETSHOWSTORENAMEINHEADER(!entry.isIntersecting))
                // console.log("entry", entry, entry.isIntersecting);
            },
            { threshold }
        );

        if (elementRef.current) observer.observe(elementRef.current);

        return () => {
            if (elementRef.current) observer.unobserve(elementRef.current);
        };
    }, [threshold]);

    return [elementRef, isVisible];
}
